import { render, staticRenderFns } from "./CyberboardR2.vue?vue&type=template&id=3939084e&scoped=true"
import script from "./CyberboardR2.vue?vue&type=script&lang=ts"
export * from "./CyberboardR2.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardR2.vue?vue&type=style&index=0&id=3939084e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3939084e",
  null
  
)

export default component.exports